export enum KlaviyoInstanceIdentifierEnum {
  EU = 'EU',
  UK = 'UK',
  US = 'US',
}

export interface KlaviyoInstance {
  id: KlaviyoInstanceIdentifierEnum
  isDefault: boolean
}

/**
 * Klaviyo instances.
 *
 * @see https://www.klaviyo.com/dashboard
 */
export const klaviyoInstances: Readonly<KlaviyoInstance[]> = [
  {
    id: KlaviyoInstanceIdentifierEnum.EU,
    isDefault: true,
  },
  {
    id: KlaviyoInstanceIdentifierEnum.UK,
    isDefault: false,
  },
  {
    id: KlaviyoInstanceIdentifierEnum.US,
    isDefault: false,
  },
]

export const getInstanceById = (id: unknown): KlaviyoInstance => {
  const instance = klaviyoInstances.find((i) => i.id === id)

  if (!instance) {
    throw new Error('Unknown Klaviyo instance.')
  }

  return instance
}
